import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import config from '../../config';
import {
  Main,
  HeaderWrapper,
  Head1,
  Head2,
  Head3,
  Content1,
  Content2,
  Content3,
  style,
  BodyItem,
  BodyWrapper,
} from './styles/UpdateLicenseStyles';

const storageTypeStrings = [
  <FormattedMessage id="company.UpdateLicense.title.displayStorageType.0" />,
  <FormattedMessage id="company.UpdateLicense.title.displayStorageType.1" />,
  <FormattedMessage id="company.UpdateLicense.title.displayStorageType.2" />,
  <FormattedMessage id="company.UpdateLicense.title.displayStorageType.3" />,
];

// SP企業向けユーザーライセンス
const createUserLicense = (
  currentCompanyInfo,
  confirmData,
  confirmDataError,
  onChange,
) => {
  const { userLicense } = confirmData;
  const licenseStyle =
    (confirmDataError.userLicense.contractNumber && {
      ...style.inputId1,
      ...style.error,
    }) ||
    style.inputId1;
  const usageState = `${currentCompanyInfo.userLicense.usedNumber}
    /${currentCompanyInfo.userLicense.contractNumber}`;
  return (
    <BodyItem>
      <Content1>
        <FormattedMessage id="company.CompanyLists.License.title.user" />
      </Content1>
      <Content2>
        <div style={style.group}>
          <input
            id="updateUserLicenseContractNumber"
            type="text"
            style={licenseStyle}
            defaultValue={userLicense.contractNumber}
            onChange={e =>
              onChange('userLicense', { contractNumber: e.target.value })
            }
          />
          <div style={style.usageTitle}>
            <FormattedMessage id="company.CompanyLists.License.title.id" />
          </div>
        </div>
      </Content2>
      <Content3>
        <div style={style.usageStateWrapper}>
          <div style={style.usageState}>{usageState}</div>
          <div style={style.usageTitle}>
            <FormattedMessage id="company.CompanyLists.License.title.id" />
          </div>
        </div>
      </Content3>
    </BodyItem>
  );
};

// SP企業向けストレージライセンス
const createStorageLicense = (
  currentCompanyInfo,
  confirmData,
  confirmDataError,
  onChange,
) => {
  const { storageLicense } = confirmData;
  const { storageType, customNumber } = storageLicense;
  const plan0 = storageType === 1;
  const plan1 = storageType === 2;
  const plan2 = storageType === 3;
  const usedMibNumber =
    (currentCompanyInfo.storageLicense.usedMibNumber > 0 &&
      Math.fround(
        currentCompanyInfo.storageLicense.usedMibNumber / 1024,
      ).toFixed(1)) ||
    '0.0';
  const licenseStyle =
    (confirmDataError.storageLicense.customNumber && {
      ...style.inputId3,
      ...style.error,
    }) ||
    style.inputId3;
  const licenseOptionStyle =
    (storageType !== 1 && style.group) || style.inputDisable;
  const usageState = `${usedMibNumber}/${currentCompanyInfo.storageLicense.contractNumber}`;
  return (
    <BodyItem>
      <Content1>
        <FormattedMessage id="company.UpdateLicense.title.storageType" />
      </Content1>
      <Content2>
        <label
          htmlFor="storagePlan0Radio"
          style={style.plan}
          className="clickableItem"
        >
          <div style={style.group}>
            <div>
              <input
                id="storagePlan0Radio"
                type="radio"
                name="plan"
                defaultChecked={plan0}
                style={style.radio}
                onClick={() => onChange('storageLicense', { storageType: 1 })}
              />
              <FormattedMessage id="company.UpdateLicense.title.storageType.1" />
            </div>
            <div style={style.rowGroup}>
              <div>
                <FormattedMessage id="company.UpdateLicense.title.storageType.1.subText" />
              </div>
            </div>
          </div>
        </label>
        <label
          htmlFor="storagePlan1Radio"
          style={style.plan}
          className="clickableItem"
        >
          <div style={style.group}>
            <div>
              <input
                id="storagePlan1Radio"
                type="radio"
                name="plan"
                defaultChecked={plan1}
                style={style.radio}
                onClick={() => onChange('storageLicense', { storageType: 2 })}
              />
              <FormattedMessage id="company.UpdateLicense.title.storageType.2" />
            </div>
          </div>
        </label>
        <label
          htmlFor="storagePlan2Radio"
          style={style.plan}
          className="clickableItem"
        >
          <div style={style.group}>
            <div>
              <input
                id="storagePlan2Radio"
                type="radio"
                name="plan"
                defaultChecked={plan2}
                style={style.radio}
                onClick={() => onChange('storageLicense', { storageType: 3 })}
              />
              <FormattedMessage id="company.UpdateLicense.title.storageType.3" />
            </div>
          </div>
        </label>
        <div style={licenseOptionStyle}>
          <FormattedMessage id="company.UpdateLicense.title.storageType.customNumber" />
          <input
            id="plan2ContractNum"
            type="text"
            style={licenseStyle}
            defaultValue={customNumber}
            onChange={e =>
              onChange('storageLicense', { customNumber: e.target.value })
            }
          />
          <div style={style.usageTitle}>
            <FormattedMessage id="company.UpdateLicense.title.storageType.customNumber.unit" />
          </div>
        </div>
      </Content2>
      <Content3>
        <div style={style.usageStateWrapper}>
          <div style={style.usageState}>{usageState}</div>
          <div style={style.usageTitle}>
            <FormattedMessage id="company.UpdateLicense.title.storageType.customNumber.unit" />
          </div>
        </div>
        <div style={style.right}>
          <FormattedMessage id="company.UpdateLicense.title.storageType.information" />
        </div>
      </Content3>
    </BodyItem>
  );
};

// SP企業向け遠隔支援ライセンス
const createRemoteSupportlLicense = (
  currentCompanyInfo,
  confirmData,
  confirmDataError,
  onChange,
) => {
  const c3 =
    confirmData.remoteSupportLicense &&
    confirmData.remoteSupportLicense.enabled;
  const licenseStyle =
    (confirmDataError.remoteSupportLicense.contractNumber && {
      ...style.inputId3,
      ...style.error,
    }) ||
    style.inputId3;
  const { remoteSupportLicense } = currentCompanyInfo;
  const usedNumber =
    (remoteSupportLicense && remoteSupportLicense.usedNumber) || 0;
  const contractNumber =
    (remoteSupportLicense && remoteSupportLicense.contractNumber) || 0;
  const usageState = `${usedNumber}/${contractNumber}`;
  return (
    <BodyItem>
      <Content1>
        <FormattedMessage id="company.UpdateLicense.title.remoteSupport" />
      </Content1>
      <Content2>
        <label htmlFor="c3" className="clickableItem">
          <div style={style.group}>
            <div>
              <input
                id="c3"
                type="checkbox"
                defaultChecked={c3}
                style={style.radio}
                onClick={e =>
                  onChange('remoteSupportLicense', {
                    enabled: e.target.checked,
                  })
                }
              />
              <FormattedMessage id="company.UpdateLicense.title.remoteSupport.enable" />
            </div>
          </div>
        </label>
        {c3 && (
          <div style={style.group}>
            <input
              id="remoteSupportLicenseNum"
              type="text"
              style={licenseStyle}
              defaultValue={confirmData.remoteSupportLicense.contractNumber}
              onChange={e =>
                onChange('remoteSupportLicense', {
                  contractNumber: e.target.value,
                })
              }
            />
            <div style={style.usageTitle}>
              <FormattedMessage id="company.UpdateLicense.title.remoteSupport.contractNumber.unit" />
            </div>
          </div>
        )}
      </Content2>
      <Content3>
        <div style={style.usageStateWrapper}>
          <div style={style.usageState}>{usageState}</div>
          <div style={style.usageTitle}>
            <FormattedMessage id="company.UpdateLicense.title.remoteSupport.contractNumber.unit" />
          </div>
        </div>
      </Content3>
    </BodyItem>
  );
};

// 一般企業向けユーザーライセンス
const createDisplayUserLicense = currentCompanyInfo => {
  const usageState = `${currentCompanyInfo.userLicense.usedNumber}/${currentCompanyInfo.userLicense.contractNumber}`;
  return (
    <BodyItem>
      <Content1>
        <FormattedMessage id="company.CompanyLists.License.title.user" />
      </Content1>
      <Content2>
        <div style={style.contractState}>
          <div>{currentCompanyInfo.userLicense.contractNumber}</div>
          <div style={style.usageTitle}>
            <FormattedMessage id="company.CompanyLists.License.title.id" />
          </div>
        </div>
      </Content2>
      <Content3>
        <div style={style.usageStateWrapper}>
          <div style={style.usageState}>{usageState}</div>
          <div style={style.usageTitle}>
            <FormattedMessage id="company.CompanyLists.License.title.id" />
          </div>
        </div>
      </Content3>
    </BodyItem>
  );
};

// 一般企業向けストレージライセンス
const createDisplayStorageLicense = currentCompanyInfo => {
  const { storageType, customNumber } = currentCompanyInfo.storageLicense;
  const usedMibNumber =
    (currentCompanyInfo.storageLicense.usedMibNumber > 0 &&
      Math.fround(
        currentCompanyInfo.storageLicense.usedMibNumber / 1024,
      ).toFixed(1)) ||
    '0.0';
  const usageState = `${usedMibNumber}/${currentCompanyInfo.storageLicense.contractNumber}`;
  const licenseOptionStyle =
    (storageType !== 1 && style.group) || style.inputDisable;
  return (
    <BodyItem>
      <Content1>
        <FormattedMessage id="company.UpdateLicense.title.displayStorageType" />
      </Content1>
      <Content2>
        <div style={style.group}>
          <div>{storageTypeStrings[storageType]}</div>
        </div>
        <div style={licenseOptionStyle}>
          <FormattedMessage id="company.UpdateLicense.title.displayStorageType.customNumber" />
          <div>
            {customNumber}
            <FormattedMessage id="company.UpdateLicense.title.displayStorageType.customNumber.unit" />
          </div>
        </div>
      </Content2>
      <Content3>
        <div style={style.usageStateWrapper}>
          <div style={style.usageState}>{usageState}</div>
          <div style={style.usageTitle}>
            <FormattedMessage id="company.UpdateLicense.title.displayStorageType.customNumber.unit" />
          </div>
        </div>
        <div style={style.right}>
          <FormattedMessage id="company.UpdateLicense.title.displayStorageType.information" />
        </div>
      </Content3>
    </BodyItem>
  );
};

// 一般企業向け遠隔支援ライセンス
const createDisplayRemoteSupportlLicense = currentCompanyInfo => {
  const usageState = `${currentCompanyInfo.remoteSupportLicense.usedNumber}/${currentCompanyInfo.remoteSupportLicense.contractNumber}`;
  return (
    <BodyItem>
      <Content1>
        <FormattedMessage id="company.UpdateLicense.title.displayRemoteSupport" />
      </Content1>
      <Content2>
        <div style={style.contractState}>
          <div>{currentCompanyInfo.remoteSupportLicense.contractNumber}</div>
          <div style={style.usageTitle}>
            <FormattedMessage id="company.UpdateLicense.title.displayRemoteSupport.contractNumber.unit" />
          </div>
        </div>
      </Content2>
      <Content3>
        <div style={style.usageStateWrapper}>
          <div style={style.usageState}>{usageState}</div>
          <div style={style.usageTitle}>
            <FormattedMessage id="company.UpdateLicense.title.displayRemoteSupport.contractNumber.unit" />
          </div>
        </div>
      </Content3>
    </BodyItem>
  );
};

const { updateLicense, displayLicense } = config.customRole.functionAccess;

const UpdateLicense = ({
  role,
  currentCompanyInfo,
  confirmData,
  confirmDataError,
  onChange,
}) => {
  const enableUpdateLicense = updateLicense.indexOf(role) !== -1;
  const enableDisplayLicense = displayLicense.indexOf(role) !== -1;
  const enableRemoteSupportLicense = confirmData.remoteSupportLicense.enabled;
  return (
    <Main>
      <div style={style.contents}>
        <HeaderWrapper>
          <Head1>
            <FormattedMessage id="company.UpdateLicense.header.item" />
          </Head1>
          <Head2>
            <FormattedMessage id="company.UpdateLicense.header.contract" />
          </Head2>
          <Head3>
            <FormattedMessage id="company.UpdateLicense.header.status" />
          </Head3>
        </HeaderWrapper>
        {enableUpdateLicense && (
          <BodyWrapper>
            {createUserLicense(
              currentCompanyInfo,
              confirmData,
              confirmDataError,
              onChange,
            )}
            {createStorageLicense(
              currentCompanyInfo,
              confirmData,
              confirmDataError,
              onChange,
            )}
            {createRemoteSupportlLicense(
              currentCompanyInfo,
              confirmData,
              confirmDataError,
              onChange,
            )}
          </BodyWrapper>
        )}
        {enableDisplayLicense && (
          <BodyWrapper>
            {createDisplayUserLicense(currentCompanyInfo)}
            {createDisplayStorageLicense(currentCompanyInfo)}
            {enableRemoteSupportLicense &&
              createDisplayRemoteSupportlLicense(currentCompanyInfo)}
          </BodyWrapper>
        )}
      </div>
    </Main>
  );
};

UpdateLicense.propTypes = {
  role: PropTypes.number.isRequired,
  currentCompanyInfo: PropTypes.object.isRequired,
  confirmData: PropTypes.object.isRequired,
  confirmDataError: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default UpdateLicense;
